export enum LogActionEnum {
  Created = 'Created',
  Edited = 'Edited',
  Updated = 'Updated',
  Renewed = 'Renewed',
  Deleted = 'Deleted',
  Restored = 'Restored',
  Paused = 'Paused',
  Resumed = 'Resumed',
  NextOfKinDeleted = 'NextOfKinDeleted',
  NextOfKinCreated = 'NextOfKinCreated',
  NextOfKinUpdated = 'NextOfKinUpdated',
}

export const LogActionLabels = {
  [LogActionEnum.Created]: 'created',
  [LogActionEnum.Edited]: 'edited',
  [LogActionEnum.Updated]: 'updated',
  [LogActionEnum.Renewed]: 'renewed',
  [LogActionEnum.Deleted]: 'deleted',
  [LogActionEnum.Restored]: 'restored',
  [LogActionEnum.Paused]: 'paused',
  [LogActionEnum.Resumed]: 'resumed',
  [LogActionEnum.NextOfKinDeleted]: 'NextOfKinDeleted',
  [LogActionEnum.NextOfKinCreated]: 'NextOfKinCreated',
  [LogActionEnum.NextOfKinUpdated]: 'NextOfKinUpdated',
};

export const LogActionLabelDescription = {
  [LogActionEnum.Created]: 'objectHasBeenCreated',
  [LogActionEnum.Edited]: 'objectHasBeenEdited',
  [LogActionEnum.Updated]: 'objectHasBeenUpdated',
  [LogActionEnum.Renewed]: 'objectHasBeenRenewed',
  [LogActionEnum.Deleted]: 'objectHasBeenDeleted',
  [LogActionEnum.Restored]: 'objectHasBeenRestored',
  [LogActionEnum.Paused]: 'objectHasBeenPaused',
  [LogActionEnum.Resumed]: 'objectHasBeenResumed',
  [LogActionEnum.NextOfKinDeleted]: 'nextOfKinHasBeenDeleted',
  [LogActionEnum.NextOfKinCreated]: 'nextOfKinHasBeenCreated',
  [LogActionEnum.NextOfKinUpdated]: 'nextOfKinHasBeenUpdated',
};
